function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "<Gruppe>"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M67.31 108h41.44"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M36.8 92H128M152 44V16a12.49 12.49 0 00-12-12H28a12.49 12.49 0 00-12 12v26.65"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M84 108V92M144 100h8"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 128,
  y: 44,
  width: 40,
  height: 72,
  rx: 6,
  ry: 6
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M93.5 59.88a13.47 13.47 0 00-19 0M103 47.93a26.94 26.94 0 00-38.07 0M112.53 35.89a40.41 40.41 0 00-57.06-.05M42.42 97.81l6.76-3.49c1.72-.54 3.39-.47 4.27.3 1.34 1.15 12.44 11.51 13.38 12.42s1.06 3.07-.76 4.85-10 8.66-12.78 8.08-14.59-2.87-32.93-28.5-16.52-37.22-16.11-40 9.8-7.92 12.13-9 4.36-.16 4.92 1c.63 1.28 6.7 15 7.35 16.54.45 1.07-.07 2.63-1.18 4s-5.61 6.7-5.61 6.7 1.7 4.47 8.48 13.93c3.2 4.57 12.08 13.17 12.08 13.17z"
});

var SvgConvergedProposition = function SvgConvergedProposition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 172 124",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgConvergedProposition;